import { Cancel } from "@mui/icons-material";
import { Avatar, useTheme, alpha } from "@mui/material";
import { DEVICE_TYPE_LAYOUT } from "../constants/deviceColumns";
import React from "react";
import { getDeviceFreshnessTime, isDeviceActive } from "../utils/deviceUtils";

const DeviceTypeAvatar = ({ device }) => {
  const theme = useTheme();

  // Get the avatar value from DEVICE_TYPE_LAYOUT
  const deviceTypeConfig = DEVICE_TYPE_LAYOUT[device.device_type];
  const avatarText = deviceTypeConfig ? deviceTypeConfig[0].avatar : null;

  // Check if device is active (updated in the last 48 hours)
  const isActive = isDeviceActive(getDeviceFreshnessTime(device));

  // Define colors based on active status
  const bgColor = isActive
    ? theme.palette.mode === "dark"
      ? alpha(theme.palette.success.dark, 0.8)
      : theme.palette.success.main
    : theme.palette.mode === "dark"
      ? alpha(theme.palette.error.dark, 0.8)
      : theme.palette.error.main;

  return (
    <Avatar
      sx={{
        fontSize: "1rem",
        backgroundColor: bgColor,
        color: "white",
        fontWeight: "bold",
        width: 40,
        height: 40,
        boxShadow: isActive
          ? `0 0 0 2px ${
              theme.palette.mode === "dark"
                ? alpha(theme.palette.success.main, 0.3)
                : alpha(theme.palette.success.light, 0.5)
            }`
          : `0 0 0 2px ${
              theme.palette.mode === "dark"
                ? alpha(theme.palette.error.main, 0.3)
                : alpha(theme.palette.error.light, 0.5)
            }`,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          transform: "scale(1.05)",
        },
      }}
    >
      {avatarText || <Cancel />}
    </Avatar>
  );
};

// Export with React.memo to prevent unnecessary re-renders when props haven't changed
export default React.memo(DeviceTypeAvatar);
